import { EventNotificationService } from "../../framework/services/event-notification";
import { LocalStorageService } from "../../framework/services/local-storage";

const STORAGE_KEY = 'Bwj.Storm.Curriculum';
const VERSION = '1.0';

export enum TutorialEvents {
  TeachShoppingPreferencesMenu = 'Tutorial.TeachShoppingPreferencesMenu',
  TeachShoppingCart = 'Tutorial.TeachShoppingCart',
}

interface ICurriculum {
  version: string | undefined;
  shoppingPreferencesMenu: boolean;
  shoppingCart: boolean;
}

class TutorialServiceClass {
  public teachShoppingPreferencesMenu() {
    const l = this.getLessons();
    l.shoppingPreferencesMenu === false
      && EventNotificationService.safeDispatch(TutorialEvents.TeachShoppingPreferencesMenu, true);
  }

  public markShoppingPreferencesMenuTaught() {
    const l = this.getLessons();
    l.shoppingPreferencesMenu = true;
    LocalStorageService.set<ICurriculum>(STORAGE_KEY, l);
    EventNotificationService.safeDispatch(TutorialEvents.TeachShoppingPreferencesMenu, false);
  }

  public teachShoppingCart() {
    const l = this.getLessons();
    l.shoppingCart === undefined && (l.shoppingCart = false);
    l.shoppingCart === false
      && EventNotificationService.safeDispatch(TutorialEvents.TeachShoppingCart, true);
  }

  public markShoppingCartTaught() {
    const l = this.getLessons();
    l.shoppingCart = true;
    LocalStorageService.set<ICurriculum>(STORAGE_KEY, l);
    EventNotificationService.safeDispatch(TutorialEvents.TeachShoppingCart, false);
  }

  private getLessons() {
    if(!!this.lessons) { return this.lessons; };
    
    this.lessons = LocalStorageService.get<ICurriculum>(STORAGE_KEY);
    if(!this.lessons || !this.lessons.version || this.lessons.version !== VERSION) {
      this.lessons = {
        version: VERSION,
        shoppingPreferencesMenu: false,
        shoppingCart: false,
      };
      LocalStorageService.set<ICurriculum>(STORAGE_KEY, this.lessons);
    }

    return this.lessons;
  }

  private lessons: ICurriculum | undefined;
}
export const TutorialService = new TutorialServiceClass();